import type { FindReplaceRule } from '@carboncopyco/types';
import { notify } from '@carboncopyco/ui';
import type { FindAndReplaceRuleFormProps } from '../../FindAndReplaceRuleForm';
import { FindAndReplaceRuleForm } from '../../FindAndReplaceRuleForm';

export interface FindAndReplaceRuleCreationProps
  extends Pick<FindAndReplaceRuleFormProps, 'rules'> {
  ruleType: FindAndReplaceRuleFormProps['type'];
  onCreate: (rule: Omit<FindReplaceRule, 'ruleId'>) => Promise<unknown>;
  onCancel: () => void;
}

export const FindAndReplaceRuleCreation = ({
  rules,
  ruleType,
  onCreate,
  onCancel,
}: FindAndReplaceRuleCreationProps) => {
  return (
    <FindAndReplaceRuleForm
      rules={rules}
      type={ruleType}
      onSubmit={(rule) =>
        onCreate({
          isGlobal: true,
          ...rule,
        })
      }
      onError={() => notify.error('Failed to create rule, please try again')}
      onCancel={onCancel}
    />
  );
};
